import React,{ createRef, useRef, useState, useEffect, useCallback } from 'react';
import { useLoading } from '../../../context/LoadingContext';
import api from '../../../apis';
import { useGlobalVariable } from '../../../context/GlobalVariableProvider';

import PathCheckerComponent from '../../../context/PathCheckerComponent';

//import { useOutletContext } from 'react-router-dom';


import { useLocalStorageListener,getUserDetail } from '../../../hooks/handleUserLocalStorage';

const Index = React.memo((props: any) => {
    const { showingTnc,showingForceChangePassword } = useGlobalVariable();

    // const [isLoading, setIsLoading] = useState(true);
    const [initLoadingDone, setInitLoadingDone] = useState(false);
    const [iframeLoaded, setIframeLoaded] = useState(false);
    //const { setIsIframe }: any = useOutletContext();

    const [tdsUrl, setTDSUrl] = useState('');
    const { loading, setLoading } = useLoading();
    
    const handleIframeLoad = () => {
        setLoading(false);
        setIframeLoaded(true);
    };

    useEffect(() => {
        //send IsIframe status to parent layer
       // if (setIsIframe) setIsIframe(true);

       //wait until show_tnc checking done only call api
        if(initLoadingDone){
                setLoading(true);
                api.getSessFeedAuth().then((result: any) => {
                    let url = result.auth_feed_url;
                    // console.log('auth_feed_url');
                    // console.log(url);
                    setTDSUrl(url);
            
                });

        }

        return () => {
           // if (setIsIframe) setIsIframe(false);
        };
    }, [initLoadingDone]);


    useLocalStorageListener((localdata) => {
        let localUser = getUserDetail();
        if (localUser) {
            if(localUser.show_tnc){

            }else{
                setInitLoadingDone(true);
            }
          
        }
        
    });

    //clear loading when display modal
    useEffect(() => {

        if(iframeLoaded == true){
            return;
        }
    
        if(showingTnc || showingForceChangePassword){
            setLoading(false); //remove loading when display tnc or force change password
        }else{
            if(initLoadingDone){
                setLoading(true);
            }
        }
      
    }, [showingTnc,showingForceChangePassword]);

    // useEffect(() => {
    //     setLoading(!showingForceChangePassword);
    // }, [showingForceChangePassword]);

    // useEffect(() => {
    //     console.log('Component rendered or re-rendered');
    // });

    // console.log("render")

    return (
        <>
            {
                !showingForceChangePassword &&
                !showingTnc &&
                <IframeComponent
                    src={tdsUrl}
                    onLoad={handleIframeLoad}
                />
            }
        </>
        
    );
});

const IframeComponent = React.memo(({ src, onLoad,onMessage }: { 
    src: string, 
    onLoad: () => void,
    onMessage?: (data: any) => void;
}) => {

    // const handleMessage = useCallback(
    //     (event: MessageEvent) => {
    //       // Optional: restrict origin
    //       // if (event.origin !== 'https://your-expected-origin.com') return;
  
    //       if (onMessage) {
    //         onMessage(event.data);
    //       }
    //     },
    //     [onMessage]
    //   );
  
    //   useEffect(() => {
    //     window.addEventListener('message', handleMessage);
    //     return () => {
    //       window.removeEventListener('message', handleMessage);
    //     };
    //   }, [handleMessage]);

      
    return (     
        <PathCheckerComponent >         
            <iframe
                onLoad={onLoad}
                src={src}
                allowFullScreen
                style={{
                    position: 'relative',
                    top: '0px',
                    left: '0px',
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    overflow: 'hidden',
                }}
            />
        </PathCheckerComponent >
                      
    );
});

export default Index;
